/* src/app/system-utils/json-forms-popup/json-forms-popup.component.scss */
.example-form {
  margin: 10px;
}
.title {
  font-weight: 600;
  font-size: 100%;
  margin-top: 14px;
  color: var(--tem-ink);
}
.main-spin {
  display: block;
  height: calc(100% - 80px);
}
:host ::ng-deep .main-spin > .ant-spin-container {
  height: 100%;
}
.main {
  overflow: auto;
  height: 100%;
}
.titleArray {
  font-weight: 600;
  font-size: 16px;
  padding-left: 10px;
  color: var(--tem-ink);
}
.link {
  text-decoration: underline;
  font-weight: 700;
  color: var(--tem-deep);
  cursor: pointer;
  font-size: 12px;
  margin: 0;
}
.buttons {
  width: 100%;
  padding: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
.spacer {
  flex: 1;
}
.buttons-divider,
.section-divider {
  margin: 0;
}
.full-width {
  width: 100%;
}
.bodyArray {
  padding-top: 7.5px;
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 15px;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  background: var(--tem-surface-2);
}
.arrayBottom {
  border-top: 0px;
  padding-top: 3.25px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}
.arrayTitle {
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}
form {
  gap: 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
/*# sourceMappingURL=json-forms-popup.component.css.map */
